module.exports = __webpack_public_path__ + "media/components/Application/Errors/logo-ffb7b5e6d90ee5ca4ca91cab205f4ede.png";